import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.details,
    details: [
      {
        label: t("push_notifications.notification_message_en"),
        name: data?.localized_data?.en?.message,
      },
      {
        label: t("push_notifications.notification_message_ar"),
        name: data?.localized_data?.ar?.message,
      },
    ],
  },

  {
    head: t("details.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.sent_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
